var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 16.2482L8 13.9115L13.7143 16.2482V2.17367H2.28571V16.2482ZM1.6 18.9109C1.21905 19.0558 0.857143 19.0239 0.514286 18.8153C0.171428 18.6073 0 18.3041 0 17.9056V2.17367C0 1.57591 0.224 1.06401 0.672 0.637972C1.11924 0.212657 1.65714 0 2.28571 0H13.7143C14.3429 0 14.8811 0.212657 15.3291 0.637972C15.7764 1.06401 16 1.57591 16 2.17367V17.9056C16 18.3041 15.8286 18.6073 15.4857 18.8153C15.1429 19.0239 14.781 19.0558 14.4 18.9109L8 16.3025L1.6 18.9109ZM2.28571 2.17367H13.7143H8H2.28571Z",
    fill: "#403E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.0a1d2af07de7917fa78020b87a92e127.svg";
export { ForwardRef as ReactComponent };